import LocalizedStrings from 'react-localization'

const localizedStrings = new LocalizedStrings({
  en: require('./locales/en-AU.json'),
  it: require('./locales/it.json')
})

// localizedStrings.setLanguage('it');

export default localizedStrings
